<template>
  <footer class="app-footer">
    <div class="container">
      <div class="up">
        <div class="up-menu" v-for="(item, index) in state.menuList" :key="index">
          <div class="title">{{ item.title }}</div>
          <div
            class="li"
            v-for="(child, idx) in item.childList"
            :key="idx"
            @click="goFaqRouter(child.code)"
          >
            {{ child.name }}
          </div>
        </div>
      </div>
      <!-- <div class="middle">
        <div class="middle-left">
          <div class="title">{{ $t('home.purchaseGuide') }}</div>
          <div class="li" @click="goFaqRouter('acbuy-forwarding-User-Guide')">
            {{ $t('home.orderStatus') }}
          </div>
          <div
            class="li"
            @click="goFaqRouter('How-is-the-purchasing-service-charged')"
          >
            {{ $t('home.serviceFee') }}
          </div>
          <div
            class="li"
            @click="goFaqRouter('Terms-of-commitment-to-no-reason-return')"
          >
            {{ $t('home.returnRefunds') }}
          </div>
        </div>
        <div class="middle-right">
          <div class="small-img">
            <img src="@/assets/images/home/reddit.png" />
            <img src="@/assets/images/home/tiktok.png" />
            <img src="@/assets/images/home/x.png" />
            <img src="@/assets/images/home/ins.png" />
            <img class="img3" src="@/assets/images/home/youtube.png" />
          </div>
          <div class="big-img">
            <img src="@/assets/images/home/google.png" />
            <img src="@/assets/images/home/app.png" />
          </div>
        </div>
      </div> -->
      <div class="bottom">
        <div class="bottom-top">
          <div class="left">
            <!-- <p class="bottom-tip">Company Name：RY ACB LIMITED</p>
            <p class="bottom-tip">Registered Number：14410280</p>
            <p class="bottom-tip">Registered Address：7 COPPERFIELD ROAD, COVENTRY WEST</p>
            <p class="bottom-tip">MIDLANDS, ENGLAND UNITED KINGDOM CV2 4AQ</p> -->
          </div>
          <div class="right">
            <img
              @click="openUrl('https://play.google.com/store/apps/details?id=com.acbuy.store')"
              src="@/assets/images/home/google-play-logo2.png"
            />
            <img
              @click="openUrl('https://apps.apple.com/app/acbuy/id6739990637')"
              src="@/assets/images/home/apple-store-logo2.png"
            />
          </div>
        </div>
        <div class="bottom-down">
          <span class="copy-right">{{ $t('home.copyRight') }}</span>
          <div class="tip-wrapper">
            <span class="text text1" @click="goFaqRouter('ACBUY-0103')">{{
              $t('home.aboutacbuy')
            }}</span>
            <span class="text text2" @click="goFaqRouter('contact-us')">{{
              $t('home.contactUs')
            }}</span>
            <span class="text text2" @click="goFaqRouter('acbuy-User-Registration-Agreement')">{{
              $t('form.termService')
            }}</span>
            <span class="text text3" @click="goFaqRouter('User-Privacy-Policy')">{{
              $t('form.privacyPolicy')
            }}</span>
          </div>
          <!-- <div class="small-img"> -->
          <!-- <img
              src="@/assets/images/home/reddit.png"
              @click="goRouterBlank('reddit')"
            /> -->
          <!-- <img
              src="@/assets/images/home/tiktok.png"
              @click="goRouterBlank('tiktok')"
            />
            <img src="@/assets/images/home/x.png" @click="goRouterBlank('x')" />
            <img
              src="@/assets/images/home/ins.png"
              @click="goRouterBlank('ins')"
            />
            <img
              class="img3"
              src="@/assets/images/home/youtube.png"
              @click="goRouterBlank('youtube')"
            /> -->
          <!-- </div> -->
          <!-- <img class="pay-img" src="@/assets/images/home/pay.png" /> -->
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { reactive } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const state = reactive({
  menuList: [
    {
      title: t('home.customerService'),
      childList: [
        {
          code: 'help-center',
          name: t('home.helpCenter'),
        },
        {
          code: '',
          name: t('home.contctTime'),
        },
        {
          code: '',
          name: t('home.contactEmail'),
        },
        {
          code: '',
          name: t('home.contactMarket'),
        },
        {
          code: '',
          name: t('home.contactCooperation'),
        },
      ],
    },
    {
      title: t('home.purchaseGuide'),
      childList: [
        {
          code: 'shopping-guide',
          name: t('home.orderStatus'),
        },
        {
          code: 'How-is-the-purchasing-service-charged',
          name: t('home.serviceFee'),
        },
        {
          code: 'Terms-of-commitment-to-no-reason-return',
          name: t('home.returnRefunds'),
        },
      ],
    },
    {
      title: t('home.payment'),
      childList: [
        {
          code: 'What-recharge-methods-are-supported-by-acbuy',
          name: t('home.topUp'),
        },
        {
          code: 'ACBUY-0101',
          name: t('home.internationalCreditCard'),
        },
        {
          code: 'ACBUY-0102',
          name: t('home.telegraphicTransfer'),
        },
      ],
    },
    {
      title: t('home.delivery'),
      childList: [
        {
          code: 'charges',
          name: t('home.charges'),
        },
        {
          code: 'Mailing-Restrictions',
          name: t('home.mailRestrictions'),
        },
        {
          code: 'Reference-for-tariff-threshold',
          name: t('home.customsTaxation'),
        },
        {
          code: 'Precautions-for-receiving-packages',
          name: t('home.receiptInformation'),
        },
      ],
    },
    {
      title: t('home.afterSaleService'),
      childList: [
        {
          code: 'How-long-can-items-be-stored-in-the-acbuy-warehouse',
          name: t('home.productStoragePeriod'),
        },
        {
          code: 'After-sales-precautions',
          name: t('home.afterSalesPolicy'),
        },
        {
          code: 'Compensation-Standards-for-Insured-Packages',
          name: t('home.insuranceAndCompensation'),
        },
      ],
    },
    // {
    //   title: t('home.customerService'),
    //   childList: [
    //     {
    //       code: 'how-to-modify-password',
    //       name: t('home.helpCenter')
    //     },
    //     {
    //       code: 'how-to-modify-password',
    //       name: t('home.contactUs')
    //     }
    //   ]
    // },

    // {
    //   title: t('home.purchaseGuide'),
    //   childList: [
    //     {
    //       code: 'acbuy-forwarding-User-Guide',
    //       name: t('home.orderStatus')
    //     },
    //     {
    //       code: 'How-is-the-purchasing-service-charged',
    //       name: t('home.serviceFee')
    //     },
    //     {
    //       code: 'Terms-of-commitment-to-no-reason-return',
    //       name: t('home.returnRefunds')
    //     }
    //   ]
    // }
  ],
})
const goFaqRouter = (code) => {
  if (code) {
    if (code === 'charges') {
      window.open('/estimation', '_blank')
    } else if (code === 'help-center') {
      window.open('/help-center', '_blank')
    } else if (code === 'shopping-guide') {
      window.open('/shopping-guide', '_blank')
    } else {
      window.open(`/doc?code=${code}`, '_blank')
    }
  }
}
const openUrl = (url) => {
  window.open(url)
}
// const goRouterBlank = (type) => {
//   let link = ''
//   switch (type) {
//     case 'reddit':
//       link = 'https://www.reddit.com/r/Acbuyofficial/'
//       break
//     case 'tiktok':
//       link = 'https://www.tiktok.com/@acbuyofficial'
//       break
//     case 'x':
//       link = 'https://x.com/acbuyofficial'
//       break
//     case 'ins':
//       link = 'https://www.instagram.com/acbuy__official/profilecard/?igsh=MXRwZzlnYnR6eHRxbQ=='
//       break
//     case 'youtube':
//       link = 'https://www.youtube.com/@acbuyofficial'
//       break
//     default:
//       break
//   }
//   window.open(link, '_blank')
// }
</script>

<style scoped lang="scss">
.app-footer {
  width: 100%;
  overflow: hidden;
  background-color: var(--black-color-1-dark);
  font-family: Montserrat;
  position: relative;
  z-index: 300;

  .container {
    width: 1320px;
    margin: auto;
    margin-top: 100px;

    .up {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .up-menu {
        .title {
          font-size: 16px;
          color: var(--white-color-1-light);
          margin-bottom: 28px;
          font-weight: bold;
        }

        .li {
          color: rgba(255, 255, 255, 0.8);
          margin-bottom: 16px;
          cursor: pointer;

          &:hover {
            color: var(--white-color-1-light);
          }
        }
      }
    }

    .middle {
      margin-top: 0px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding-bottom: 12px;
      margin-bottom: 40px;
      border-bottom: 1px solid rgba(225, 225, 225, 0.1);

      .middle-left {
        .title {
          font-size: 16px;
          color: var(--white-color-1-light);
          margin-bottom: 28px;
          font-weight: bold;
        }

        .li {
          color: var(--white-color-8);
          margin-bottom: 16px;
          cursor: pointer;

          &:hover {
            color: var(--white-color-1-light);
          }
        }
      }

      .middle-right {
        // margin-top: 74px;
        width: 350px;

        .small-img {
          display: flex;
          justify-content: flex-end;

          img {
            width: 32px;
            height: 32px;
            margin-right: 30px;
          }

          .img3 {
            margin-right: 0;
          }
        }

        .big-img {
          display: flex;
          justify-content: space-between;
          width: 350px;
          margin-top: 30px;

          img {
            width: 159px;
            height: 50px;
            cursor: pointer;
          }
        }
      }
    }

    .bottom {
      margin-top: 40px;
      margin-bottom: 60px;

      .bottom-top {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          .bottom-tip {
            color: rgba(255, 255, 255, 0.6);
            font-size: 14px;
          }
        }

        .right {
          > img {
            cursor: pointer;
            width: 159px;
            height: 50px;

            &:first-of-type {
              margin-right: 30px;
            }
          }
        }
      }

      .bottom-up {
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        padding-bottom: 30px;

        .pay-logo-list {
          display: flex;
          margin-bottom: 16px;
        }

        .pay-logo {
          width: 72px;
          margin-right: 24px;
          background-color: var(--white-color-1-light);
          border-radius: 4px;
        }

        .card-address {
          font-size: 14px;
          font-weight: normal;
          line-height: normal;
          color: var(--white-color-1-light);
          margin-bottom: 10px;
        }

        .email-block {
          width: 342px;
          height: 52px;
          border-radius: 801px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: rgba(225, 225, 225, 0.1);

          .text {
            font-size: 16px;
            font-weight: bold;
            color: rgba(255, 255, 255, 0.2);
            margin-left: 40px;
          }

          .email {
            width: 40px;
            height: 40px;
            margin-right: 6px;
            cursor: pointer;
          }
        }
      }

      .bottom-down {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .copy-right {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.6);
        }

        .tip-wrapper {
          text-align: center;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.6);
          height: 15px;
          line-height: 15px;

          .text {
            padding: 0 10px;
            cursor: pointer;

            &:hover {
              color: var(--white-color-1-light);
            }
          }

          .text1,
          .text2 {
            border-right: 1px solid rgba(225, 225, 225, 0.6);
          }
        }

        .small-img {
          display: flex;
          justify-content: flex-end;

          img {
            width: 32px;
            height: 32px;
            margin-right: 30px;
            cursor: pointer;
          }

          .img3 {
            margin-right: 0;
          }
        }

        .pay-img {
          width: 190px;
          height: 22px;
        }
      }
    }
  }
}
</style>
